import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { EmailTemplate } from '../email-template';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { TemplateLink } from '../template-link';
import { CKEDITORCONFIG, CKEDITORCONFIGDEV } from '../ckeditor-config';
import { ActivatedRoute, Router } from '@angular/router';
import { GmailMessage } from '../gmail-message';
import { WpContactRequest } from '../wp-contact-request';
import { Language } from '../language';
import { ToastMessageService } from '../toast-message.service';
import { GmailService } from '../service/gmail.service';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent implements OnInit {

  emailTemplates: EmailTemplate[] = [];
  selectedTemplate!: EmailTemplate | null;
  addingNew = false;
  updatingTemplate = false;
  templateForm!: FormGroup;
  titleOrBodyIsEmpty = false;
  newTemplateLinks: TemplateLink[] = [];
  makingCombinedTemplate = false;
  searchTerm = "";
  searchOption = "title";
  ckEditorNgModel!: string;
  selectedLanguage: Language | null = null;
  languages: Language[] = [];
  languageOptions: any = [];


  responseMailForm!: FormGroup;

  editorValue: string = "";
  editorConfig: any = CKEDITORCONFIG;
  devConfig = CKEDITORCONFIGDEV;

  sendingEmail = false;
  hasGoogleRefreshToken = true;

  combinedEditorConfig: any = {
    toolbar: [
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting', '-', 'Radio', '-', 'Undo', 'Redo', '-', 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent'] },
      { name: 'secondLine', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'Image', 'Iframe'] },
      '\\',
      { name: 'colors', items: ['TextColor', 'BGColor'] },

      { name: 'styles', items: ['Styles', 'Format', 'Font'] }
    ],
    removeButtons: "Save,Source,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,Table,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "450px",
    width: "400px",
    enterMode: 2
  };

  selectedContactRequest: WpContactRequest | null = null;

  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private gmailService: GmailService
  ) {
    let selectedRequestId = this.route.snapshot.paramMap.get("requestId");
    if (selectedRequestId) {
      httpService.getWpContactRequestById(Number(selectedRequestId)).subscribe(res => {
        this.selectedContactRequest = res;
        this.initResponseMailForm();
      });
    } else {
      this.initNewMailForm();
    }
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
      for (let language of this.languages) {
        this.languageOptions.push({ label: this.toTitleCase(language.name), value: language });
      }
      this.selectedLanguage = this.languages[0];
      this.initTemplateForm();
      this.initTemplateList();
    });
  }

  initTemplateForm() {
    this.templateForm = this.builder.group({
      title: ["", Validators.required],
      body: ["", Validators.required],
      language: [this.languages[0], Validators.required],
      links: this.builder.array([this.createFormItem()])
    });
  }

  initResponseMailForm() {
    this.responseMailForm = this.builder.group({
      to: this.selectedContactRequest!.email,
      subject: "",
      body: ""
    });
  }
  initNewMailForm(){
    this.responseMailForm = this.builder.group({
      to: "",
      subject: "",
      body: ""
    });
  }

  get linksFormArray(){
    let linksFormArray = this.templateForm.get('links') as FormArray;
    return linksFormArray.controls;
  }

  resetResponseMailForm() {
    this.responseMailForm.get("to")!.setValue("");
    this.responseMailForm.get("subject")!.setValue("");
    this.responseMailForm.get("body")!.setValue("");
  }

  ngOnInit() {
  }

  initTemplateList() {
    this.httpService.getEmailTemplatesByLanguage(this.selectedLanguage!).subscribe(res => {
      this.emailTemplates = res;
      this.sortTemplates();
      this.addingNew = false;
      this.makingCombinedTemplate = true;
    });
  }

  sortTemplates() {
    this.emailTemplates.sort((a, b) => {
      if (a.title == null) {
        a.title = "";
      }
      if (b.title == null) {
        b.title = "";
      }
      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return 1;
      }
      else if (a.title.toLowerCase() == b.title.toLowerCase()) {
        return 0;
      }
      else return -1;
    });
  }

  deleteTemplate() {
    if (confirm("Do you want to delete? \nTitle: " + this.selectedTemplate!.title)) {
      this.httpService.deleteEmailTemplate(this.selectedTemplate!).subscribe(() => {
        this.selectedTemplate = null;
        this.addingNew = false;
        this.updatingTemplate = false;
        this.httpService.getEmailTemplates().subscribe(res => {
          this.emailTemplates = res;
          this.sortTemplates();
        });
      });
    }
  }

  addTemplate() {
    this.addingNew = true;
    this.selectedTemplate = null;
    this.makingCombinedTemplate = false;
    this.initTemplateForm();
  }
  cancelAdd() {
    this.templateForm.reset();
    this.titleOrBodyIsEmpty = false;
    this.addingNew = false;
    this.makingCombinedTemplate = true;
  }

  addCombinedTemplate() {
    this.addingNew = false;
    this.makingCombinedTemplate = true;
    this.selectedLanguage = this.languages[0];
    this.initTemplateList();
  }
  addSelected() {
    if (this.selectedTemplate) {
      this.responseMailForm.get("body")!.setValue(this.responseMailForm.value.body + this.selectedTemplate.body);
    }
  }
  cancelCombinedTemplate() {
    this.makingCombinedTemplate = false;
    this.selectedTemplate = null;
    this.selectedLanguage = this.languages[0];
  }

  editTemplate() {
    this.updatingTemplate = true;
    this.templateForm = this.builder.group({
      title: [this.selectedTemplate!.title, Validators.required],
      body: [this.selectedTemplate!.body, Validators.required],
      language: [this.selectedTemplate!.language, Validators.required],
      links: this.builder.array([])
    });
    this.addItemFromTemplate();
    this.addItem();
  }
  cancelEdit() {
    this.updatingTemplate = false;
    this.titleOrBodyIsEmpty = false;
    this.selectedLanguage = this.languages[0];
    this.templateForm.reset();
  }

  sendForm() {
    this.titleOrBodyIsEmpty = false;
    if (this.templateForm.value.title == "" || this.templateForm.value.body == "" || this.templateForm.value.title == null || this.templateForm.value.body == null) {
      this.titleOrBodyIsEmpty = true;
      return;
    }
    let template = new EmailTemplate(
      this.templateForm.value.title, this.templateForm.value.body, [], this.templateForm.value.language, null);
    template.templateLinks = [];
    this.setTemplateLinks(template);

    this.httpService.postEmailTemplate(template).subscribe(res => {
      this.addingNew = false;
      this.makingCombinedTemplate = true;
      this.templateForm.reset();
      this.templateForm.value.links = [];
      this.selectedTemplate = res;
      this.httpService.getEmailTemplatesByLanguage(this.selectedLanguage!).subscribe(res => {
        this.emailTemplates = res;
        this.sortTemplates();
      });
    });
  }

  setTemplateLinks(template: EmailTemplate) {
    if (this.templateForm.value.links.length == 0) {
      template.templateLinks = [];
      return;
    } else {
      for (let link of this.templateForm.value.links) {
        if (link.url == null || link.url == undefined || link.url == "") {
          continue;
        } else if (link.text == null || link.text == undefined) {
          link.text = "";
        }
        template.templateLinks.push(new TemplateLink(
          null,
          link.url.trim(),
          link.text.trim(),
          null
        ));
      }
    }
  }

  setUpdatedTemplateLinks(template: EmailTemplate) {
    let linksToUpdate = [];
    let linksToPost = [];
    if (this.selectedTemplate!.templateLinks.length > 0) {
      for (let link of this.selectedTemplate!.templateLinks) {
        linksToUpdate.push(
          new TemplateLink(
            this.selectedTemplate!,
            link.url,
            link.text,
            link.id
          )
        );
      }
    }
    for (let i = 0; i < this.selectedTemplate!.templateLinks.length; i++) {
      linksToUpdate[i].url = this.templateForm.value.links[i].url;
      linksToUpdate[i].text = this.templateForm.value.links[i].text;
    }
    for (let j = this.selectedTemplate!.templateLinks.length; j < this.templateForm.value.links.length; j++) {
      if (this.templateForm.value.links[j].url == "" ||
        this.templateForm.value.links[j].url == null ||
        this.templateForm.value.links[j].url == undefined
      ) {
        continue;
      }
      linksToPost.push(new TemplateLink(
        this.selectedTemplate!,
        this.templateForm.value.links[j].url,
        this.templateForm.value.links[j].text
      ));
    }
    template.templateLinks = linksToUpdate;
    this.newTemplateLinks = linksToPost;
  }

  updateTemplate() {
    this.titleOrBodyIsEmpty = false;
    if (this.templateForm.value.title == "" || this.templateForm.value.body == "" || this.templateForm.value.title == null || this.templateForm.value.body == null) {
      this.titleOrBodyIsEmpty = true;
      return;
    }
    if (!this.selectedTemplate) {
      return;
    }
    const template = new EmailTemplate(this.templateForm.value.title, this.templateForm.value.body, [], this.selectedLanguage!, this.selectedTemplate.id);
    this.setUpdatedTemplateLinks(template);
    this.httpService.putEmailTemplate(template).subscribe(res => {
      this.selectedTemplate = res;
      this.httpService.postTemplateLinks(this.newTemplateLinks).subscribe(() => {
        this.updatingTemplate = false;
        this.httpService.getEmailTemplatesByLanguage(this.selectedLanguage!).subscribe(res => {
          this.emailTemplates = res;
          this.sortTemplates();
          this.toastService.addSuccess("Template updated", template.title + " is successfully updated !");
        }, error => {
          this.toastService.addError("failed to save template", "failed to get updated template");
        });
      }, error => {
        this.toastService.addError("failed to save template", "failed to post links for this template");
      });
    }, error => {
      this.toastService.addError("failed to save template", "failed to put template to update");
    });
  }

  createFormItem(): FormGroup {
    return this.builder.group({
      url: ["", Validators.required],
      text: [""]
    });
  }
  addItem(): void {
    let items = this.templateForm.get("links") as FormArray;
    items.push(this.createFormItem());
  }
  addItemFromTemplate(): void {
    let items = this.templateForm.get("links") as FormArray;
    for (let link of this.selectedTemplate!.templateLinks) {
      items.push(this.builder.group({
        url: [link.url, Validators.required],
        text: [link.text]
      }))
    }
  }

  copyLink(index: number) {
    let link = document.getElementById("link" + index);
    let range = document.createRange();
    range.selectNode(link!);
    const selection = window.getSelection();
    selection!.removeAllRanges();
    selection!.addRange(range);
    document.execCommand("copy");
  }

  copyContent() {
    let content = document.getElementById("template-body");
    let range = document.createRange();
    range.selectNode(content!);
    const selection = window.getSelection();
    selection!.removeAllRanges();
    selection!.addRange(range);
    document.execCommand("copy");
  }

  copyEditorValue() {
    let content = document.getElementById("someEditor");
    let range = document.createRange();
    range.selectNode(content!);
    const selection = window.getSelection();
    selection!.removeAllRanges();
    selection!.addRange(range);
    document.execCommand("copy");
  }

  selectTemplate(template: EmailTemplate) {
    this.selectedTemplate = template;
    this.templateForm = this.builder.group({
      title: [this.selectedTemplate.title, Validators.required],
      body: [this.selectedTemplate.body, Validators.required],
      links: this.builder.array([]),
      language: this.selectedTemplate.language
    });
  }

  selectChange() {
    this.updatingTemplate = true;
    this.templateForm = this.builder.group({
      title: [this.selectedTemplate!.title, Validators.required],
      body: [this.selectedTemplate!.body, Validators.required],
      links: this.builder.array([]),
      language: this.selectedTemplate!.language
    });
    this.addItemFromTemplate();
    this.addItem();
  }

  clearCombinedEditor(){
    this.responseMailForm.get("body")!.setValue("");
  }

  compareId(lang1: Language, lang2: Language): boolean {
    return lang1 && lang2 ? lang1.id === lang2.id : lang1 === lang2;
  }

  switchLanguage() {
    this.httpService.getEmailTemplatesByLanguage(this.selectedLanguage!)
      .subscribe(res => {
        this.emailTemplates = res;
        this.sortTemplates();
        this.templateForm.get("body")!.setValue("");
        this.templateForm.get("title")!.setValue("");
        this.templateForm.value.links = [];
      });
  }

  toTitleCase(str: string) {
    let firstLetter = str[0];
    let majLetter = firstLetter.toUpperCase();
    return str.replace(firstLetter, majLetter);
  }

  sendGmail() {
    this.sendingEmail = true;
    console.log("proccessing");
    this.httpService.checkGmailRefreshToken().subscribe(res => {
      if (res == false) {
        this.sendingEmail = false;
        this.hasGoogleRefreshToken = false;
        return;
      } else {
        let message = new GmailMessage(
          [this.responseMailForm.value.to],
          this.responseMailForm.value.subject,
          this.responseMailForm.value.body
        );
        if(this.selectedContactRequest){
          this.sendResponseToContactRequest(message);
        } else {
          this.sendNewGmail(message);
        }
      }
    });
  }

  sendResponseToContactRequest(message: GmailMessage){
    this.httpService.sendWpContactRequestResponseByGoogle(message, this.selectedContactRequest!.id!).subscribe(() => {
      this.toastService.addSuccess("Mail sent 👏👏", "Email is sent. Bravo 👏👏");
      this.router.navigateByUrl("/management/email-template");
      this.selectedContactRequest = null;
      this.resetResponseMailForm();
      this.sendingEmail = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.sendingEmail = false;
    });
  }

sendNewGmail(message: GmailMessage){
    this.httpService.sendHtmlEmailByGoogleWithQuotations(this.gmailService.getFormData(message, [])).subscribe(() => {
      this.toastService.addSuccess("Mail sent 👏👏", "Email is sent. Bravo 👏👏");
      this.resetResponseMailForm();
      this.sendingEmail = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.sendingEmail = false;
    });
  }
}
